import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

/**
 * Makes a host element (the LPR plate / vehicle thumbnails) an accessible button that opens the
 * enlarged vehicle-image preview. Single source of truth for the clickable class, ARIA role/tabindex/
 * title and the click + Enter/Space keyboard handlers shared by both preview images.
 */
@Directive({
  selector: '[appImagePreviewTrigger]',
  standalone: true,
})
export class ImagePreviewTriggerDirective {
  /** When false the element is inert (no pointer/keyboard affordance). */
  @Input('appImagePreviewTrigger') enabled = true;

  @Output() previewTrigger = new EventEmitter<void>();

  @HostBinding('class.order-request-lpr-axis-image--clickable')
  get isClickable(): boolean {
    return this.enabled;
  }

  @HostBinding('attr.role')
  get role(): string | null {
    return this.enabled ? 'button' : null;
  }

  @HostBinding('attr.tabindex')
  get tabindex(): number | null {
    return this.enabled ? 0 : null;
  }

  @HostBinding('attr.title')
  get title(): string | null {
    return this.enabled ? 'Click to view full vehicle image' : null;
  }

  @HostListener('click')
  @HostListener('keydown.enter')
  onActivate(): void {
    this.trigger();
  }

  @HostListener('keydown.space', ['$event'])
  onSpace(event: Event): void {
    event.preventDefault();
    this.trigger();
  }

  private trigger(): void {
    if (this.enabled) {
      this.previewTrigger.emit();
    }
  }
}
